import { Card, CardHeader, Button } from "@/components/primitives";
import { PageHeader } from "@/components/Layout";
import { IncidentDetail } from "@/components/IncidentDetail";
import { useSnapshot } from "@/lib/snapshot-context";

export function Incidents() {
  const { data } = useSnapshot();
  const active = data.incidents.filter((i) => i.status !== "resolved");
  const resolved = data.incidents.filter((i) => i.status === "resolved");

  return (
    <>
      <PageHeader
        crumbs={["Status Watch", "Incidents"]}
        title="Incidents"
        subtitle={`${active.length} active · ${resolved.length} resolved in the last 30 days`}
        actions={
          <Button variant="outline" icon="download">
            Export
          </Button>
        }
      />
      <div
        style={{
          padding: "20px 32px 28px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <Card>
          <CardHeader
            title="Active"
            description={`${active.length} ongoing`}
          />
          {active.map((inc) => (
            <IncidentDetail key={inc.id} incident={inc} collapsed />
          ))}
          {active.length === 0 && (
            <div
              style={{
                padding: 24,
                textAlign: "center",
                color: "var(--muted-foreground)",
                fontSize: 13,
              }}
            >
              No active incidents.
            </div>
          )}
        </Card>
        <Card>
          <CardHeader
            title="Resolved"
            description={`${resolved.length} in the last 30 days`}
          />
          {resolved.map((inc) => (
            <IncidentDetail key={inc.id} incident={inc} collapsed />
          ))}
        </Card>
      </div>
    </>
  );
}
